import { type Rrule } from '@/stores/user'
import { TIERS_ENUM, CARD_CODE_TARS_ENUM } from '@/constants/loyalty'

export enum BRAND_LEVEL {
  LUXURY = 'LUXURY',
  PREMIUM = 'PREMIUM',
  MIDSCALE = 'MIDSCALE',
  ECONOMY = 'ECONOMY'
}

export enum SUBSCRIPTION_NAME {
  ALLPLUS_IBIS = 'allplus-ibis',
  ALLPLUS_VOYAGEUR = 'allplus-voyageur',
  ALLPLUS_EXPLORER = 'allplus-explorer',
  ALL_SIGNATURE = 'all-signature'
}

export enum ALL_PLUS_PRODUCT_CODE {
  ALL_PLUS_EXPLORER = '3086167',
  ALL_PLUS_IBIS = '3081432',
  ALL_PLUS_VOYAGEUR = '3085163'
}

export enum ALL_SIGNATURE_PLAN {
  SIGPL0 = 'SIGPL0',
  SIGPL1 = 'SIGPL1',
  SIGPL2 = 'SIGPL2',
  SIGPL3 = 'SIGPL3'
}

export enum allSignaturePlanName {
  essential = 'essential',
  discover = 'discover',
  explorer = 'explorer',
  absolute = 'absolute'
}

export enum ALL_SIGNATURE_STATUS {
  ACTIVE = 'active',
  PENDING_CANCELLATION = 'pending_cancellation',
  PAST_DUE = 'past_due'
}

export const PLAN_KEY_BY_CODE: Record<ALL_SIGNATURE_PLAN, allSignaturePlanName> = {
  [ALL_SIGNATURE_PLAN.SIGPL0]: allSignaturePlanName.essential,
  [ALL_SIGNATURE_PLAN.SIGPL1]: allSignaturePlanName.discover,
  [ALL_SIGNATURE_PLAN.SIGPL2]: allSignaturePlanName.explorer,
  [ALL_SIGNATURE_PLAN.SIGPL3]: allSignaturePlanName.absolute
}

export const enum ALL_PLUS_SUBSCRIPTION_STATUS {
  ACTIVE = 'ACTIVE',
  EXPIRES_SOON = 'EXPIRES_SOON',
  EXPIRED = 'EXPIRED'
}

export enum FREQUENCY_TYPE {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  YEARLY = 'yearly'
}

export const RRULE_TO_FREQUENCY: Record<Rrule, FREQUENCY_TYPE> = {
  'FREQ=MONTHLY;INTERVAL=1': FREQUENCY_TYPE.MONTHLY,
  'FREQ=MONTHLY;INTERVAL=3': FREQUENCY_TYPE.QUARTERLY,
  'FREQ=YEARLY;INTERVAL=1': FREQUENCY_TYPE.YEARLY
}

export const ALL_PLUS_EXPLORER_RENEW_URL = 'https://checkout.accorplus.com/membership/renew'

export const SOUSCRIPTION_AND_PLAN_LABELS_GTM: Record<
  SUBSCRIPTION_NAME | ALL_SIGNATURE_PLAN,
  string
> = {
  [SUBSCRIPTION_NAME.ALLPLUS_EXPLORER]: 'all accor plus explorer',
  [SUBSCRIPTION_NAME.ALLPLUS_VOYAGEUR]: 'all accor plus voyageur',
  [SUBSCRIPTION_NAME.ALLPLUS_IBIS]: 'all accor plus ibis',
  [SUBSCRIPTION_NAME.ALL_SIGNATURE]: 'all signature',

  [ALL_SIGNATURE_PLAN.SIGPL0]: 'signature essential',
  [ALL_SIGNATURE_PLAN.SIGPL1]: 'signature discover',
  [ALL_SIGNATURE_PLAN.SIGPL2]: 'signature explorer',
  [ALL_SIGNATURE_PLAN.SIGPL3]: 'signature absolute'
}

export type SouscriptionAndPlanLabel =
  (typeof SOUSCRIPTION_AND_PLAN_LABELS_GTM)[keyof typeof SOUSCRIPTION_AND_PLAN_LABELS_GTM]

export enum StatusLevel {
  Gold = TIERS_ENUM.GOLD,
  Silver = TIERS_ENUM.SILVER,
  Platinum = TIERS_ENUM.PLATINUM
}

export type StatusLevelType = `${StatusLevel}`

export const IBIS_CARD = {
  code: CARD_CODE_TARS_ENUM.FI,
  product: ALL_PLUS_PRODUCT_CODE.ALL_PLUS_IBIS
}
export const ALL_VOYAGEUR_CARD = {
  code: CARD_CODE_TARS_ENUM.B3,
  product: ALL_PLUS_PRODUCT_CODE.ALL_PLUS_VOYAGEUR
}
export const ALL_EXPLORER_CARD = {
  code: CARD_CODE_TARS_ENUM.G7,
  product: ALL_PLUS_PRODUCT_CODE.ALL_PLUS_EXPLORER
}
